// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2obxt","content":"LoadingAlert_content__1yaKo"};